import { useQuery } from "@tanstack/react-query";
import type { FundingApplicationSchemas } from "api-types";
import { useAxios } from "auth-sdk";
import { getInReviewDetailsQuery } from "shared-ui";

import { FUNDING_APPLICATION_REVIEW_AIR_API } from "../../components/constants";

export const useInReviewDetails = (customerDomain: string, ready = true) => {
  return useQuery(getInReviewDetailsQuery(customerDomain, ready));
};

export const useAIRDetails = (customerDomain: string, airId: string) => {
  const client = useAxios();
  const airUrl = FUNDING_APPLICATION_REVIEW_AIR_API.replace(":customerSlug", customerDomain) + "?airId=" + airId;
  return useQuery({
    queryKey: [airUrl],
    queryFn: () => client.get<FundingApplicationSchemas.AIRSchema>(airUrl),
    select: ({ data }): FundingApplicationSchemas.AIRSchema => data,
    refetchOnMount: true,
    refetchInterval: 30000,
  });
};
